export default {
  status: null,
  category: null,
  supplier: null,
  sector: null,
  dateForOffer: null,
}
